
export const commonTranslations = {
  // Hero Section tagline
  heroTagline: {
    fr: "Action • Collaboration • Innovation • Impact",
    en: "Action • Collaboration • Innovation • Impact"
  },
  // Navbar
  visionMission: {
    fr: "Vision & Mission",
    en: "Vision & Mission"
  },
  services: {
    fr: "Services",
    en: "Services"
  },
  members: {
    fr: "Annuaire",
    en: "Directory"
  },
  join: {
    fr: "Rejoindre",
    en: "Join"
  },
  joinLeaders: {
    fr: "Rejoindre Leaders",
    en: "Join Leaders"
  },

  // Navigation Menu
  vision: {
    fr: "Vision",
    en: "Vision"
  },
  benefits: {
    fr: "Bénéfices",
    en: "Benefits"
  },
  targetAudience: {
    fr: "À qui",
    en: "For whom"
  },
  testimonials: {
    fr: "Témoignages",
    en: "Testimonials"
  },
};
